module.exports = __webpack_public_path__ + "static/carbon-b04f763f19a60d79d9ac5a1c6e2d4894.jpg";